import { Component, inject } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { AcceptInvitationStepBase } from '../../shared/accept-invitation-step-base/accept-invitation-step-base';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-ownership-disclosure',
  templateUrl: './ownership-disclosure.component.html',
  styleUrl: './ownership-disclosure.component.scss'
})
export class OwnershipDisclosureComponent extends AcceptInvitationStepBase<any> {
  public override readonly form = inject(FormBuilder).group({
    noIndividualOver25: ['', Validators.required]
  });

  public override nextUrl: string | null = null;
  public override readonly previousUrl = '../business-location';
  protected override readonly storageKey = 'ownershipDisclosureForm';

  protected override loadFormData(): void {
    super.loadFormData();
    const fieldValue = this.form.get('noIndividualOver25')?.value ?? null;
    if (fieldValue !== '' && fieldValue !== null) {
      this.selectNextUrl(fieldValue);
    }
  }

  public readonly ownershipOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' }
  ];

  public onOwnershipChange(event: MatSelectChange) {
    const value = event.value
    this.selectNextUrl(value);
  }

  private selectNextUrl(value: string) {
    if (value === 'yes') {
      this.nextUrl = '../additional-owners';
    } else {
      this.nextUrl = '../link-bank-account';
    }
  }
}
